import Link from "next/link";
import Logo from "./logo";
import { Button } from "./button";

export default function LandingPageHeader() {
  return (
    <div>
      <header className="w-full z-30 sticky top-0 bg-white h-[50px] border-b">
        <div className="mx-auto container px-lg sm:px-xl h-full flex flex-col gap-sm justify-evenly">
          <nav className="flex items-center justify-between">
            <div className="flex grow justify-between align-text-bottom font-semibold">
              <div className="flex justify-between sm:justify-start gap-2xl sm:gap-4xl lg:gap-5xl items-center">
                <Logo />
                {/* <Link
                  className="hidden sm:flex text-sm hover:underline"
                  href="/pricing"
                >
                  Pricing
                </Link> */}
              </div>

              <div className="gap-4xl lg:gap-5xl flex justify-between items-center">
                <Link href="/dashboard">
                  <Button>LOG IN</Button>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </div>
  );
}
